import styled from 'styled-components';
import { theme } from '@/theme/Theme';

const PolicyWrapper = styled.div<{ isMobile: boolean }>`
  width: 100vw;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: ${({ isMobile }) => isMobile ? '0' : 'auto'};
  bottom: ${({ isMobile }) => isMobile ? '0' : '-200px'};

  .cover {
    width: 100%;
    height: ${({ isMobile }) => isMobile ? '100dvh' : 'auto'};
    display: ${({ isMobile }) => isMobile ? 'flex' : 'block'};
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);

    .content {
      box-sizing: border-box;
      width: ${({ isMobile }) => isMobile ? 'calc(100vw - 40px)' : '100%'};
      max-width: ${({ isMobile }) => isMobile ? '480px' : 'none'};
      max-height: ${({ isMobile }) => isMobile ? 'calc(100dvh - 40px)' : 'none'};
      overflow: auto;
      position: relative;
      border: ${({ isMobile }) => isMobile ? 'none' : '1px solid black'};
      border-radius: ${({ isMobile }) => isMobile ? '10px' : '0'};
      background: #fff;
      padding: ${({ isMobile }) => isMobile ? '44px 20px 20px' : '25px 100px 20px 20px'};
      color: ${theme.colors.gray500};
    }
  }

  transition: ${({ isMobile }) => isMobile ? 'none' : 'bottom 1s ease'};
  &.active { bottom: 0; }
  &.hidden { display: none; }
`;

const CloseBtn = styled.button<{ isMobile: boolean }>`
  position: absolute;
  right: ${({ isMobile }) => isMobile ? '4px' : '20px'};
  top: ${({ isMobile }) => isMobile ? '4px' : '12px'};
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export { PolicyWrapper, CloseBtn };
